module.exports = __webpack_public_path__ + "static/media/loader-light.598b65ea.svg";